import React, { useEffect } from 'react';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { TabView, TabPanel } from 'primereact/tabview';
import { Calendar } from 'primereact/calendar';

const GeneralItems = ({ generalItems, productProperties, editable, employees, removeGeneralItems, handleGeneralItemsChange }) => {

  const handleDropdownChange = (e, index, key) => {
    const newGeneralItems = [...generalItems];
    newGeneralItems[index] = { ...newGeneralItems[index], [key]: e.value };
    handleGeneralItemsChange(index, newGeneralItems[index]);
  };

  const handleInputChange = (event, index, key) => {
    const value = event.target.value;
    const newGeneralItems = [...generalItems];
    newGeneralItems[index] = { ...newGeneralItems[index], [key]: value };
    handleGeneralItemsChange(index, newGeneralItems[index]);
  };

  const actionTemplate = (rowData, column) => {
    return <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => removeGeneralItems(column.rowIndex)} />;
  };

  const flavorOptions = [{ label: 'None', value: null }, ...productProperties[0]?.flavors.cakes.sort().map(cake => ({ label: cake, value: cake }))];

  return (
    <>
      
          <DataTable value={generalItems} size="small" editMode="cell">
            {editable || generalItems.some(item => item.item) ? 
            <Column field="item" header="Item" editor={editable ? (props) =>
              <InputText value={generalItems[props.rowIndex]?.item} onChange={(e) => handleInputChange(e, props.rowIndex, 'item')} />
              : null} />
            : null}
            {editable || generalItems.some(item => item.quantity) ?
            <Column field="quantity" header="Quantity" editor={editable ? (props) =>
              <InputText value={generalItems[props.rowIndex]?.quantity} onChange={(e) => handleInputChange(e, props.rowIndex, 'quantity')} />
              : null} />
            : null}
            {editable || generalItems.some(item => item.description) ?
            <Column field="description" header="Description" editor={editable ? (props) =>
              <InputText value={generalItems[props.rowIndex]?.description} onChange={(e) => handleInputChange(e, props.rowIndex, 'description')} />
              : null} />
            : null}
            {editable || generalItems.some(item => item.flavor) ?
            <Column field="flavor" header="Flavor" editor={editable ? (props) =>
              <Dropdown value={props.rowData['flavor']} filter options={flavorOptions} onChange={(e) => handleDropdownChange(e, props.rowIndex, 'flavor')} />
              : null} />
            : null}
            {editable || generalItems.some(item => item.flavorNotes) ?
            <Column field="flavorNotes" header="Flavor Notes" editor={editable ? (props) =>
              <InputText value={generalItems[props.rowIndex]?.flavorNotes} onChange={(e) => handleInputChange(e, props.rowIndex, 'flavorNotes')} />
              : null} />
            : null}
            {editable || generalItems.some(item => item.decoratingNotes) ?
            <Column field="decoratingNotes" header="Decorating Notes" editor={editable ? (props) =>
              <InputText value={generalItems[props.rowIndex]?.decoratingNotes} onChange={(e) => handleInputChange(e, props.rowIndex, 'decoratingNotes')} />
              : null} />
            : null}
            {editable || generalItems.some(item => item.price) ?
            <Column field="price" header="Price" editor={editable ? (props) =>
              <InputText value={generalItems[props.rowIndex]?.price} onChange={(e) => handleInputChange(e, props.rowIndex, 'price')} />
              : null} />
            : null}
            {editable && <Column body={actionTemplate} style={{ textAlign: 'center', width: '8em' }} />}
          </DataTable>
        
    </>
  );
};

export default GeneralItems;
